import { useOutlet } from 'react-router-dom';

/**
 * Outlet do AppShell.
 * Sem AnimatePresence: `mode="wait"` + `useOutlet()` trava a UI após
 * algumas navegações (tela em branco, dados não montam).
 */
export function RouteTransition() {
  const outlet = useOutlet();
  // flex-1 + min-h-0: quando o ancestral (main) tem altura definida (rotas em
  // tela cheia, ver isFullBleedCanvas no AppShell), isso propaga a altura
  // exata pro componente da rota; em páginas normais (main sem altura fixa)
  // não muda nada -- continua se ajustando ao conteúdo como sempre.
  return <div className="flex w-full flex-1 flex-col min-h-0">{outlet}</div>;
}
